import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { Space, Spinner } from "@masterteam/mt-design-react";

import Statuses from "../Dashboard/Statuses";
import CardsSection from "../Dashboard/CardsSection";
import DashboardHeader from "../Dashboard/DashboardHeader";
import ObjectivesSectorsPerformance from "../Dashboard/ObjectivesSectorsPerformance";

import api from "../../providers/api";
import { addToast } from "../../helpers";

import "./style.scss";

const SectorsDashboard = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [data, setData] = useState(null);
  const [kpiStatuses, setKpiStatuses] = useState([]);
  const [projectStatuses, setProjectStatuses] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [years, setYears] = useState([]);
  const [filters, setFilters] = useState({
    year: null,
    sectors: [],
    quarter: null
  });

  const quarters = useSelector(({ theme }) => theme.Quarters.item.Items);

  const getData = async () => {
    try {
      setIsLoading(true);
      const [dataRes] = await Promise.all([
        api.dashboard.getSectorsPerformanceData({
          Sectors: filters?.sectors?.map((e) => e.ID),
          Year: filters?.year?.Value,
          Quarter: filters?.quarter?.Value
        })
      ]);
      setSectors(dataRes?.Data?.SectorsList || []);
      setData(dataRes.Data);
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error"
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getFiltersData = async () => {
    try {
      setFiltersLoading(true);
      const [yearsRes, kpiStatusesRes, projectStatusesRes, filterDateRes] = await Promise.all([
        api.dashboard.getValidYears(),
        api.handshake.getKPIStatuses(),
        api.handshake.getProjectStatuses(),
        api.dashboard.getFilterDate()
      ]);
      setYears(
        yearsRes.Data?.map((e) => {
          return { Label: e, Value: e };
        })
      );

      setKpiStatuses(kpiStatusesRes?.Data);
      setProjectStatuses(projectStatusesRes?.Data);

      // const today = new Date();
      // const currentYear = today.getFullYear();
      // const currentQuarter = Math.floor((today.getMonth() + 3) / 3);

      setFilters({
        sectors: [],
        year: { Label: filterDateRes?.Data?.Year, Value: filterDateRes?.Data?.Year },
        quarter: quarters?.find((e) => +e.Value === filterDateRes?.Data?.Quarter),
      });
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error"
      });
    } finally {
      setFiltersLoading(false);
    }
  };

  useEffect(() => {
    getFiltersData();
  }, []);

  useEffect(() => {
    if (filters.year && filters.quarter) getData();
  }, [filters]);

  return filtersLoading ? (
    <div className="loader-container">
      <Spinner size="large" />
    </div>
  ) : (
    <Space className="sectors-dashboard" direction="vertical" size="large">
      <DashboardHeader
        dashboardTitle="dashboards.sectors-performance"
        sectors={sectors}
        years={years}
        quarters={quarters}
        isLoading={isLoading || filtersLoading}
        filters={filters}
        setFilters={setFilters}
        isSectorsDashboard
      />

      {isLoading ? (
        <div className="loader-container">
          <Spinner size="large" />
        </div>
      ) : (
        <>
          <Space
            direction="vertical"
            size="large"
            className="sectors-dashboard__body"
          >
            <CardsSection
              data={data?.OrgStructures}
              kpiStatuses={kpiStatuses}
              projectStatuses={projectStatuses}
              title="dashboards.level-one-kpis-projects-performance"
              isSectors
            />
            <ObjectivesSectorsPerformance
              data={data}
              kpiStatuses={kpiStatuses}
              projectStatuses={projectStatuses}
            />
            <CardsSection
              data={data?.ObjectiveGroupedOrgStructures}
              kpiStatuses={kpiStatuses}
              projectStatuses={projectStatuses}
              title="dashboards.level-two-kpis-projects-performance"
              isSectors
              filterValue={filters?.sectors}
              filtersList={sectors}
              handleFilterOnChange={(item) => {
                setFilters({ ...filters, sectors: item });
              }}
              filtersLabel="common.sectors"
            />
            <CardsSection
              data={data?.OrgStructureGroupedObjectives}
              kpiStatuses={kpiStatuses}
              projectStatuses={projectStatuses}
              title="dashboards.level-two-objective-kpis-project-performance"
              filterValue={filters?.sectors}
              filtersList={sectors}
              handleFilterOnChange={(item) => {
                setFilters({ ...filters, sectors: item });
              }}
              filtersLabel="common.sectors"
            />
          </Space>

          <Statuses
            thresholds={kpiStatuses}
            projectStatuses={projectStatuses}
          />
        </>
      )}
    </Space>
  );
};

export default SectorsDashboard;
